(function () {
  // Only run on small screens (adjust breakpoint if you want)
  const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;

  // Utility: find primary + secondary image elements inside a product card
  function findImages(card) {
    const primary =
      card.querySelector('.product-card__image--primary, .card__media img[data-image="primary"], img.is-primary, img.primary') ||
      card.querySelector('.card__media img, .media img, img');

    let secondary =
      card.querySelector('.product-card__image--secondary, .hover-image, img.is-secondary, img.secondary, [data-hover-image]');

    if (!secondary) {
      const imgs = card.querySelectorAll('img');
      if (imgs.length >= 2) secondary = imgs[1];
    }

    if (primary && secondary && !card.classList.contains('ap-swap-ready')) {
      card.classList.add('ap-swap-ready', 'ap-touch-hover');
      primary.classList.add('ap-swap-primary');
      secondary.classList.add('ap-swap-secondary');
    }

    return { primary, secondary };
  }

  // Show / hide handlers
  function showSecondary(card) {
    const { primary, secondary } = findImages(card);
    if (!secondary || !primary) return;
    primary.style.opacity = '0';
    secondary.style.opacity = '1';
  }

  function showPrimary(card) {
    const { primary, secondary } = findImages(card);
    if (!secondary || !primary) return;
    primary.style.opacity = '';
    secondary.style.opacity = '';
  }

  // Extra: lock down Android/iOS context menus
  function hardenAgainstContextMenu(card) {
    const imgs = card.querySelectorAll('img');
    imgs.forEach((img) => {
      img.addEventListener('contextmenu', (e) => e.preventDefault());
      img.setAttribute('draggable', 'false');
    });
  }

  // Bind listeners
  function bindCards(root = document) {
    const cards = root.querySelectorAll(
      '[data-product-card], .product-card, .card--product, .product-grid-item, li.grid__item .card'
    );

    cards.forEach((card) => {
      if (card.__apPressBound) return;
      card.__apPressBound = true;

      const onPointerDown = (e) => {
        if (!isMobile()) return;
        if (e.pointerType && e.pointerType !== 'touch') return;
        if (e.cancelable) e.preventDefault();
        showSecondary(card);
      };

      const onPointerUp = () => {
        if (!isMobile()) return;
        showPrimary(card);
      };

      const onPointerCancel = () => {
        if (!isMobile()) return;
        showPrimary(card);
      };

      if (window.PointerEvent) {
        card.addEventListener('pointerdown', onPointerDown, { passive: false });
        card.addEventListener('pointerup', onPointerUp, { passive: true });
        card.addEventListener('pointercancel', onPointerCancel, { passive: true });
        card.addEventListener('pointerleave', onPointerUp, { passive: true });
      } else {
        card.addEventListener('touchstart', (e) => {
          if (!isMobile()) return;
          if (e.cancelable) e.preventDefault();
          showSecondary(card);
        }, { passive: false });

        ['touchend', 'touchcancel'].forEach((evt) => {
          card.addEventListener(evt, () => {
            if (!isMobile()) return;
            showPrimary(card);
          }, { passive: true });
        });
      }

      // Also restore on scroll
      window.addEventListener('scroll', () => {
        if (!isMobile()) return;
        showPrimary(card);
      }, { passive: true });

      // Harden context menu for Android/iOS
      hardenAgainstContextMenu(card);
    });
  }

  // Init after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindCards());
  } else {
    bindCards();
  }

  // Rebind after AJAX section loads (Shopify sections)
  document.addEventListener('shopify:section:load', (e) => bindCards(e.target || document));
  document.addEventListener('shopify:section:select', (e) => bindCards(e.target || document));

  // Global fallback: stop context menu inside product cards
  document.addEventListener(
    'contextmenu',
    function (e) {
      const card = e.target.closest('[data-product-card], .product-card, .card--product, .product-grid-item, li.grid__item .card');
      if (card) e.preventDefault();
    },
    { capture: true }
  );
})();
